<div class="py-4 container-fluid disb-reg-page">
  <h4 class="mb-4 disb-reg-title">ข้อมูลเอกสารส่งเบิก</h4>

  @if (isDocumentOfficerRole) {
    <div class="disb-reg-card disb-reg-cover-memo-card">
      <div class="disb-reg-card-body">
        <div class="disb-reg-cover-memo-header">
          <div>
            <h6 class="disb-reg-cover-memo-title">ใบปะหน้าบันทึกข้อความ (เอกสารที่ 1)</h6>
            <p class="disb-reg-cover-memo-caption">
              ใบปะหน้าบันทึกข้อความฉบับเดียวสำหรับทั้งคณะในภาคการศึกษานี้ — แนบไปพร้อมกับเอกสารรวมของแต่ละสาขาวิชาในไฟล์ ZIP รายสาขา
            </p>
          </div>
          <span class="disb-reg-cover-memo-status" [ngClass]="coverMemoStatusClass()">
            {{ coverMemoStatusLabel() }}
          </span>
        </div>

        @if (coverMemoLoading()) {
          <p class="disb-reg-cover-memo-loading">กำลังโหลดข้อมูล...</p>
        } @else {
          @if (coverMemo(); as memo) {
            <div class="disb-reg-cover-memo-meta">
              <span>เลขที่เอกสาร: {{ memo.document_number || '-' }}</span>
              <span>วันที่มีผล: {{ memo.effective_date || '-' }}</span>
              <span>จำนวนอาจารย์: {{ memo.entries_count ?? 0 }}</span>
            </div>
            <button
              type="button"
              class="btn btn-outline-primary btn-sm"
              [disabled]="memo.status_code !== 'certified'"
              [title]="memo.status_code !== 'certified' ? 'ดาวน์โหลดได้เมื่อรับรองแล้วเท่านั้น' : ''"
              (click)="onDownloadCoverMemo()"
            >
              ดาวน์โหลดใบปะหน้าบันทึกข้อความ
            </button>
          } @else {
            <p class="disb-reg-cover-memo-empty">ยังไม่มีบันทึกข้อความขอสอนเกินภาระงานสำหรับภาคการศึกษานี้</p>
          }
        }
      </div>
    </div>

    <div class="disb-reg-card">
      <div class="disb-reg-card-body">
        <h6 class="disb-reg-section-heading">ดาวน์โหลดชุดเอกสารรายสาขาวิชา (สำหรับสารบัญ)</h6>
        <p class="disb-reg-section-caption">
          ไฟล์ ZIP ประกอบด้วยบันทึกข้อความของคณะ + เอกสารรวมพร้อมส่งเบิกของแต่ละใบรับรองที่เสร็จสมบูรณ์แล้วในสาขาวิชานั้น
          ครอบคลุมทั้งรอบส่งอีเมลวันจันทร์ตามปกติและใบรับรองที่ตกค้างหลังครบ 4 รอบ
        </p>

        @if (departmentZipLoading()) {
          <p class="disb-reg-cover-memo-loading">กำลังโหลดข้อมูล...</p>
        } @else if (departmentZipRows().length === 0) {
          <p class="disb-reg-cover-memo-empty">ยังไม่มีใบรับรองที่เสร็จสมบูรณ์สำหรับภาคการศึกษานี้</p>
        } @else {
          <div class="disb-reg-dept-zip-list">
            @for (row of departmentZipRows(); track row.departmentId) {
              <div class="disb-reg-dept-zip-row">
                <span class="disb-reg-dept-zip-name">{{ row.departmentName }}</span>
                <span class="disb-reg-dept-zip-count">{{ row.completedCount }} ใบรับรอง</span>
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm"
                  [disabled]="downloadingDepartmentId() === row.departmentId"
                  (click)="onDownloadDepartmentZip(row)"
                >
                  {{ downloadingDepartmentId() === row.departmentId ? 'กำลังดาวน์โหลด...' : 'ดาวน์โหลด ZIP' }}
                </button>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }

  <div class="disb-reg-card">
    <div class="disb-reg-card-body">
      <div class="disb-reg-toolbar" [formGroup]="filterForm">
        <div class="disb-reg-filter">
          <app-select
            label="เทอมการศึกษา"
            formControlName="academicTerm"
            [options]="academicTermNameOptions"
            [clearable]="false"
            [searchable]="false"
            classes="mb-0"
          ></app-select>
        </div>

        <div class="disb-reg-filter">
          <app-select
            label="ปีการศึกษา"
            formControlName="academicYear"
            [options]="academicYearOptions"
            [clearable]="false"
            [searchable]="false"
            classes="mb-0"
          ></app-select>
        </div>

        <div class="disb-reg-search">
          <app-filter-search-input
            label="ค้นหา"
            formControlName="keywords"
            ariaLabel="ค้นหาข้อมูลเอกสารส่งเบิก"
            classes="mb-0"
            (searchSubmit)="onSearch()"
          ></app-filter-search-input>
        </div>
      </div>

      @if (enableTestProvisionTrigger) {
        <div class="disb-reg-test-trigger" [formGroup]="testProvisionForm">
          <span class="disb-reg-test-trigger-badge">ทดสอบเท่านั้น</span>
          <div class="disb-reg-test-trigger-select">
            <app-select
              label="เทอมที่จะเปิดรอบ"
              formControlName="termId"
              [options]="testProvisionTermOptions"
              bindLabel="label"
              bindValue="id"
              [clearable]="false"
              [searchable]="false"
              classes="mb-0"
            ></app-select>
          </div>
          <button
            type="button"
            class="btn btn-outline-danger btn-sm"
            [disabled]="testProvisionForm.getRawValue().termId === null"
            (click)="onOpenTestProvisionDialog()"
          >
            ทดสอบ: เปิดรอบเบิกจ่าย
          </button>
        </div>
      }

      <ng-template #statusTemplate let-row="row">
        <span class="disb-reg-status" [ngClass]="statusBadgeClass(row.statusCode)">
          {{ row.statusLabel }}
        </span>
      </ng-template>

      <ng-template #actionTemplate let-row="row">
        <button
          type="button"
          class="btn disb-reg-action-button datatable-view-action-button"
          aria-label="ดูข้อมูลเอกสารส่งเบิก"
          (click)="onView(row)"
        >
          <img
            src="assets/media/icons/svg/eye.svg"
            class="disb-reg-action-icon datatable-view-action-icon"
            alt=""
            aria-hidden="true"
          />
        </button>
      </ng-template>

      <app-datatable
        [datasource]="datasource()"
        [columns]="columns"
        [isLoading]="tableLoading()"
        [limit]="10"
        (sortChange)="onSortChange($event)"
      ></app-datatable>

      <app-table-pagination
        [page]="datasource().page"
        [limit]="datasource().limit"
        [total]="datasource().total"
        [totalPage]="datasource().total_page"
        [offset]="datasource().offset"
        [dataLength]="datasource().data.length"
        ariaLabel="disbursement registry pagination"
        (pageChange)="onPageChange($event)"
        (limitChange)="onLimitChange($event)"
      ></app-table-pagination>
    </div>
  </div>
</div>

@if (detailOpen()) {
  <div class="disb-reg-modal-overlay" role="presentation">
    <div
      class="disb-reg-modal-panel"
      role="dialog"
      aria-modal="true"
      aria-labelledby="disbRegDetailTitle"
    >
      @if (selectedRow(); as row) {
        <div class="disb-reg-detail-header">
          <div>
            <h5 id="disbRegDetailTitle">{{ row.teacherName }}</h5>
            <span class="disb-reg-status" [ngClass]="statusBadgeClass(row.statusCode)">
              {{ row.statusLabel }}
            </span>
          </div>
          <button type="button" class="btn-close" aria-label="ปิด" (click)="onCloseDetail()"></button>
        </div>

        <div class="disb-reg-detail-body">
          <div class="disb-reg-detail-meta">
            <span>ภาคการศึกษา: {{ row.academicTermLabel }}</span>
            <span>สาขาวิชา: {{ row.departmentName }}</span>
            <span>ภาค: {{ row.pathLabel }}</span>
            <span>วันที่เสร็จสมบูรณ์: {{ row.completedAtLabel }}</span>
          </div>

          <div class="disb-reg-doc-section">
            <h6>เอกสารส่งเบิกที่คำนวณแล้ว</h6>
            @for (docType of calcSectionDocTypes(row); track docType) {
              <div class="disb-reg-doc-row">
                <span>{{ docLabel(docType) }}</span>
                <button
                  type="button"
                  class="btn btn-outline-primary btn-sm"
                  [disabled]="isDownloadingDoc(docType)"
                  (click)="onDownloadDocument(docType)"
                >
                  {{ isDownloadingDoc(docType) ? 'กำลังดาวน์โหลด...' : 'ดาวน์โหลด' }}
                </button>
              </div>
            }
          </div>

          <div class="disb-reg-doc-section">
            <h6>ตารางเรียนตารางสอน</h6>
            @for (docType of scheduleSectionDocTypes(); track docType) {
              <div class="disb-reg-doc-row">
                <span>{{ docLabel(docType) }}</span>
                <button
                  type="button"
                  class="btn btn-outline-primary btn-sm"
                  [disabled]="isDownloadingDoc(docType)"
                  (click)="onDownloadDocument(docType)"
                >
                  {{ isDownloadingDoc(docType) ? 'กำลังดาวน์โหลด...' : 'ดาวน์โหลด' }}
                </button>
              </div>
            }
          </div>

          <div class="disb-reg-doc-section disb-reg-merged-section">
            <h6>เอกสารรวมพร้อมส่งเบิก</h6>
            <div class="disb-reg-doc-row">
              <span>{{ docLabel('merged') }}</span>
              <button
                type="button"
                class="btn btn-primary btn-sm"
                [disabled]="isDownloadingDoc('merged')"
                (click)="onDownloadMerged()"
              >
                {{ isDownloadingDoc('merged') ? 'กำลังดาวน์โหลด...' : 'ดาวน์โหลด' }}
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}

<app-confirm-dialog
  #testProvisionDialog
  modalId="disbursementRegistryTestProvisionDialog"
  icon="warning"
  title="ทดสอบ: เปิดรอบเบิกจ่าย (ทดสอบเท่านั้น)"
  message="ต้องการเปิดรอบเบิกจ่ายสำหรับเทอมนี้ทันทีหรือไม่ ? การทำงานนี้มีผลจริงในฐานข้อมูล ใช้สำหรับทดสอบเท่านั้น"
  cancelText="ยกเลิก"
  confirmText="ยืนยันเปิดรอบเบิกจ่าย"
  [isProcessing]="testProvisionLoading()"
  (confirmed)="onConfirmTestProvision()"
></app-confirm-dialog>
